export default "__VITE_ASSET__EQ5Pv4Xo__"